import { Box, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Drawer from "@mui/material/Drawer";
import GoogleMapReact from "google-map-react";
import React, { useEffect, useState } from "react";
import Marker from "./Marker";

function PickupOptions(props) {
	const [open, setOpen] = useState(false);
	const [chosenPickup, setChosenPickup] = useState(null);
	const [chosenPickupDate, setChosenPickupDate] = useState(null);
	const [checked, setChecked] = useState(false);

	useEffect(() => {
		props.setChosenPickupOption(chosenPickupDate);
	}, [chosenPickupDate]);

	useEffect(() => {
		if (!checked) {
			props.readyToPlaceOrder(false);
		}
	}, [checked]);

	return (
		<div style={{ height: "70vh", width: "300px" }}>
			<GoogleMapReact
				bootstrapURLKeys={{ key: "" }}
				defaultCenter={props.defaultCoordinates.center}
				defaultZoom={props.defaultCoordinates.zoom}
				yesIWantToUseGoogleMapApiInternals
			>
				{props.pickupPoints
					? props.pickupPoints.map((item) => {
							return (
								<Marker
									key={item.id}
									text={item.name}
									lat={item.latitude}
									lng={item.longitude}
									onClick={() => {
										setOpen(true);
										setChosenPickup(item);
									}}
								/>
							);
					  })
					: null}
			</GoogleMapReact>
			<Drawer
				anchor={"bottom"}
				open={open}
				onClose={() => {
					setOpen(false);
					setChecked(false);
				}}
			>
				{chosenPickup ? (
					<Box sx={{ width: "auto", padding: 2 }} role="presentation">
						<center>
							<img
								style={{ width: "150px", height: "150px" }}
								src={chosenPickup.logo}
							></img>
							<Typography>{chosenPickup.name}</Typography>
							<Typography>{chosenPickup.city}</Typography>
							<Typography>{chosenPickup.postcode}</Typography>

							<FormControl component="fieldset">
								<RadioGroup
									aria-label="gender"
									name="gender1"
									value={chosenPickupDate}
									onChange={(event) => setChosenPickupDate(event.target.value)}
									align="left"
								>
									{chosenPickup.open.map((date) => (
										<FormControlLabel
											value={
												chosenPickup.name +
												";" +
												chosenPickup.id +
												";" +
												date.date +
												";" +
												date.open +
												";" +
												date.close
											}
											control={<Radio color="primary" />}
											label={
												date.name_of_day +
												" " +
												date.date +
												": " +
												date.open +
												"-" +
												date.close
											}
										/>
									))}
								</RadioGroup>
							</FormControl>

							{chosenPickupDate && (
								<FormControlLabel
									control={
										<Checkbox
											color="primary"
											checked={checked}
											onChange={() => setChecked(!checked)}
											inputProps={{ "aria-label": "primary checkbox" }}
										/>
									}
									label="Bevestig uw ophaaldatum"
								/>
							)}

							{checked && (
								<Button
									style={{
										height: "50px",
										width: "150px",
										display: "inline-block",
										fontSize: "12px",
										marginRight: "5px",
										marginLeft: "5px",
										fontWeight: "bold",
									}}
									color="primary"
									variant="contained"
									onClick={() => props.readyToPlaceOrder(true)}
								>
									Volgende stap
								</Button>
							)}
						</center>
					</Box>
				) : null}
			</Drawer>
		</div>
	);
}

export default PickupOptions;
